type Currency = { key: string; label: string };

export const CurrenciesSelectModalComponent: ng.IComponentOptions = {
  bindings: {
    onClose: '&',
    onSelect: '<',
    defaultCurrency: '<',
  },
  templateUrl: 'products/modals/currencies-select/currencies-select-modal.html',
  controller: class CurrenciesSelectController {
    onSelect: (currency: string) => void;

    currencies: string[] = [];
    selectedCurrency: string;
    searchField = '';
    defaultCurrency: string;

    allCurrencies = [
      'EUR',
      'USD',
      'AED',
      'AUD',
      'BHD',
      'BRL',
      'CAD',
      'CHF',
      'CNY',
      'CZK',
      'DKK',
      'EGP',
      'FJD',
      'GBP',
      'HKD',
      'HUF',
      'ILS',
      'INR',
      'JOD',
      'JPY',
      'KWD',
      'LBP',
      'MAD',
      'MOP',
      'MYR',
      'NOK',
      'NTD',
      'NZD',
      'OMR',
      'PLN',
      'QAR',
      'RON',
      'SAR',
      'SEK',
      'SGD',
      'THB',
      'VND',
      'XPF',
    ];

    constructor(private readonly $q: ng.IQService, private searchUtilsService) {
      'ngInject';
    }

    $onInit() {
      this.selectedCurrency = this.defaultCurrency;
      this.currencies = this.allCurrencies;
    }

    setCurrencies(currencies: string[]): void {
      this.currencies = currencies;
    }

    getFilterFn(search: string) {
      const regStr =
        this.searchUtilsService.getRegexStringWithDiacritics(search);
      const reg = this.searchUtilsService.getSearchRegex(regStr);

      return (entity) => reg.test(entity);
    }

    onSearchChange(): void {
      if (this.searchField) {
        const filterFn = this.getFilterFn(this.searchField);
        const filteredEntities = this.allCurrencies.filter((currency) =>
          filterFn(currency)
        );

        return this.setCurrencies(filteredEntities);
      }
      return this.setCurrencies(this.allCurrencies);
    }

    onSubmitSelect(): void {
      return this.onSelect(this.selectedCurrency);
    }
  },
};
